angular.module('core')
  .service('classroomAlertsApi', [
        'cancelableResourceFactory',
        'cancelableResourceManager',
        'transformResponse',
    function (
        cancelableResourceFactory,
        cancelableResourceManager,
        transformResponse
    ) {
    this.getClassroomAlerts = getClassroomAlerts;

    var ClassroomAlerts = cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/classrooms/:classroomId/alerts', {}, {
        get: {
            method: 'GET',
            isArray: false,
            cache: false,
            transformResponse: function (body) {
                try {
                    return JSON.parse(body);
                }
                catch (e) {
                    console.error('Alert Transform Error:', e.message);
                    return {};
                }
            }
        }
    });

    function getClassroomAlerts(districtId, classroomId, ast, days, fd, td) {
        var params = {
            districtId: districtId,
            classroomId: classroomId,
            ast: ast
        };

        var resource = ClassroomAlerts.get(params);
        cancelableResourceManager.addAndRemoveOnFinish(resource);

        return resource.$promise;
    }
}]);
